import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { SEARCH_TEMPLATE_PASSAGE_QUESTION } from 'queries/questionPassage'
import {
  searchTemplatePassageQuestion,
  searchTemplatePassageQuestionVariables,
} from '__generatedTypes__/searchTemplatePassageQuestion'

export function castParams({
  page,
  take,
  search,
}: Params<Record<string, unknown>>): searchTemplatePassageQuestionVariables {
  return {
    searchString: search,
    skip: (page - 1) * take,
    take,
  }
}

export function useQuestionPassageTemplates() {
  return useQueryWithParams<
    searchTemplatePassageQuestion,
    searchTemplatePassageQuestionVariables,
    'searchTemplatePassageQuestion',
    'items',
    'count'
  >(SEARCH_TEMPLATE_PASSAGE_QUESTION, 'searchTemplatePassageQuestion', 'items', 'count', castParams, undefined, {
    fetchPolicy: 'network-only',
  })
}
